export default "/dist/files/icon_edito.1791b416f2593fea41c2479ef74b055d.svg";